<template>
  <div>
    <el-row>
      <h2>配送单管理</h2>
    </el-row>
    <el-row>
      <el-form :model="searchForm" ref="searchForm" :inline="true">
        <el-form-item label="送货日期：">
          <el-date-picker v-model="searchForm.date" type="date" placeholder="选择日期" :clearable="false">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="分组：">
          <el-select v-model="searchForm.groupID" style="width:80%" :clearable="true">
            <el-option v-for="item in groupList" :key="item.ID" :label="item.GROUP_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品名称：">
          <el-input placeholder="产品名称" v-model="searchForm.name" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button v-preventReClick @click="queryTable" style="float:right" :loading="loadSearch">筛选</el-button>
        </el-form-item>
        <el-button v-preventReClick @click="exportNoExcel">不带序号导出</el-button>
        <el-button v-preventReClick @click="exportExcel">带序号导出</el-button>
        <el-button v-preventReClick @click="exportPriceExcel">带价格导出</el-button>
        <el-button v-preventReClick @click="exportWithPurchasePrice">带采购价导出</el-button>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="10">
        <span>{{ this.name }}</span>
      </el-col>
    </el-row>
    <el-row style="margin-top:20px">
      <el-col :data="tableData" v-for="item in tableData" :key="item.INCOME_DATE">
        <table cellpadding="0" cellspacing="0" style="width:100%" class="sending">
          <caption class="table-title" style="">{{ item.D_NAME }}</caption>
          <tr class="table-line" v-for="index in item.DATA" :key="index.INCOME_DATE">
            <td class="product" style="width:60%;">{{ index.P_NAME }}</td>
            <td class="product" style="width:20%;text-align:center">{{ index.PRODUCT_COUNT }}</td>
            <td class="product" style="width:150px;text-align:center">{{ index.TYPE_UNIT }}</td>
          </tr>
        </table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import date from '@/assets/common/date';

export default {
  data () {
    return {
      searchForm: {
        date: date(new Date(), '%F'),
      },
      tableData: [],
      loadSearch: false,
      name: '',
      groupList: [],
    };
  },
  methods: {
    exportWithPurchasePrice () {
      const params = {
        SERVICE_ID: '10083',
        OTYPE: 5,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        SEND_DAY: date(this.searchForm.date, '%F'),
      };
      if (this.searchForm.groupID) {
        params.GROUP_ID = this.searchForm.groupID;
      }
      this.loadSearch = true;
      http.post(params).then((res) => {
        if (res[0] && res[0].FILE_PATH) {
          window.open(this.$util.getURLLocalHost(res[0].FILE_PATH));
        }
        this.loadSearch = false;
      }).catch((error) => {
        this.loadSearch = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryTable () {
      const params = {
        SERVICE_ID: '10083',
        OTYPE: 1,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        SEND_DAY: date(this.searchForm.date, '%F'),
      };
      if (this.searchForm.groupID) {
        params.GROUP_ID = this.searchForm.groupID;
      }
      if (this.searchForm.name) {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      this.loadSearch = true;
      http.post(params).then((res) => {
        if (res[0].FLAG === 0) {
          this.loadSearch = false;
          this.tableData = res[0].DATA;
          this.name = res[0].COMPANY_NAME;
        } else if (res[0].FLAG === 2) {
          this.loadSearch = false;
          this.$message.show({
            text: '暂无数据',
            type: 'warning',
          });
        } else {
          this.loadSearch = false;
          this.$confirm('您选择日期的订单中存在未分类的产品，请先进行分类?', '提示', {
            confirmButtonText: '立即前往',
            type: 'warning',
            showClose: false,
            showCancelButton: false,
          }).then(() => {
            this.$router.push({ name: 'PurchaseMatchProduct' });
            sessionStorage.setItem('sendDay', date(this.searchForm.date, '%F'));
          });
        }
      }).catch((error) => {
        this.loadSearch = false;
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    queryGroup () {
      const params = {
        SERVICE_ID: '10081',
        OTYPE: 4,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PAGESIZE: 10 ** 10,
        PAGEINDEX: 0,
      };
      http.post(params).then((result) => {
        this.groupList = result[0].OP_ROLE;
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    exportExcel () {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10083',
            OTYPE: 4,
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
            SEND_DAY: date(this.searchForm.date, '%F'),
          };
          if (this.searchForm.groupID) {
            params.GROUP_ID = this.searchForm.groupID;
          }
          http.post(params).then((result) => {
            window.location.href = result[0].FILE_PATH;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({
              text: error,
              type: 'error',
            });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    exportNoExcel () {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10083',
            OTYPE: 2,
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
            SEND_DAY: date(this.searchForm.date, '%F'),
          };
          if (this.searchForm.groupID) {
            params.GROUP_ID = this.searchForm.groupID;
          }
          http.post(params).then((result) => {
            window.location.href = result[0].FILE_PATH;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({
              text: error,
              type: 'error',
            });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    exportPriceExcel () {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10083',
            OTYPE: 3,
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
            SEND_DAY: date(this.searchForm.date, '%F'),
          };
          if (this.searchForm.groupID) {
            params.GROUP_ID = this.searchForm.groupID;
          }
          http.post(params).then((result) => {
            if (result[0].ERROR_MSG) {
              this.$message.show({
                text: result[0].ERROR_MSG,
                type: 'warning',
              });
            }
            window.location.href = result[0].FILE_PATH;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({
              text: error,
              type: 'error',
            });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
  },
  created () {
    // 这里用来在系统设置中设置页面展示条目，文件在systemSetting的unitManage中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.queryGroup();
  },
};
</script>
<style scoped>
.product {
  color: #606266;
  padding-left: 5px;
  height: 40px;
}

.table-title {
  height: 50px;
  line-height: 50px;
  border: 1px solid #ebeef5;
  color: #909399;
  font-weight: bold;
  border-bottom: 0;
}

.table-line {
  float: left;
  width: 25%;
}

.sending,
.sending tr th,
.sending tr td {
  border: 1px solid #ebeef5;
}
</style>



// WEBPACK FOOTER //
// src/components/sortingAndDistribution/sendingDocumentSupplier.vue